// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1FWkS","icon":"style_icon__3QeZ4","title":"style_title__2DaNk"};